/* ServiceBenefits - Reassurance strip with four key service benefits
 * Displays compact benefit cards for delivery, quality, advice, and planting service.
 */

import { Truck, Leaf, Phone, Sprout } from 'lucide-react';

const benefits = [
  {
    icon: Truck,
    title: 'Snelle levering',
    text: 'Door heel Nederland, veilig verpakt',
  },
  {
    icon: Leaf,
    title: 'Topkwaliteit',
    text: 'Direct van de kweker uit Dedemsvaart',
  },
  {
    icon: Phone,
    title: 'Persoonlijk advies',
    text: 'Bel of WhatsApp ons bij vragen',
  },
  {
    icon: Sprout,
    title: 'Aanplantservice',
    text: 'Wij planten uw haag professioneel aan',
  },
];

export default function ServiceBenefits() {
  return (
    <section className="mb-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {benefits.map((benefit) => (
          <div
            key={benefit.title}
            className="flex flex-col items-center text-center sm:p-6"
          >
            <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-md bg-[#e7e1d6] text-[#1e2b22]">
              <benefit.icon className="h-5 w-5" strokeWidth={1.75} />
            </div>
            <h3 className="text-sm font-semibold text-[#1e2b22] mb-1">{benefit.title}</h3>
            <p className="text-xs leading-5 text-[#5a6552]">{benefit.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
